import AppointmentDetails from 'components/HappeningNonContent/ServiceBooking/AppointmentDetails/AppointmentDetails';

export default AppointmentDetails;
